var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppConsoleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 159,
    viewBox: "0 0 140 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.9375C20 4.44917 24.4772 0 30 0C35.5229 0 40 4.44917 40 9.9375V149.062C40 154.551 35.5229 159 30 159C24.4772 159 20 154.551 20 149.062V9.9375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 9.9375C100 4.44917 104.477 0 110 0C115.523 0 120 4.44917 120 9.9375V149.062C120 154.551 115.523 159 110 159C104.477 159 100 154.551 100 149.062V9.9375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99.375C60 115.84 46.5685 129.187 30 129.187C13.4315 129.187 0 115.84 0 99.375C0 82.91 13.4315 69.5625 30 69.5625C46.5685 69.5625 60 82.91 60 99.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140 59.625C140 76.09 126.569 89.4375 110 89.4375C93.4315 89.4375 80 76.09 80 59.625C80 43.16 93.4315 29.8125 110 29.8125C126.569 29.8125 140 43.16 140 59.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppConsoleLogo);
export default __webpack_public_path__ + "static/media/app-console-logo.8ca4eca4dd8f5cfc9f49f25dd97d00c4.svg";
export { ForwardRef as ReactComponent };